import React from "react";
import Header from "./components/General/Header";
import RegisterComp from "./components/General/Register.component";

const Register = () => {
  return (
    <>
      <Header />
      <RegisterComp />
    </>
  );
};

export default Register;
